import { apiRequest } from "./apiClient";
import type { ApiResponse } from "./apiClient";

export type ContactRequestType = "bug" | "feature" | "feedback" | "support";

export const CONTACT_REQUEST_TYPES: { value: ContactRequestType; label: string }[] = [
  { value: "bug", label: "Bug Report" },
  { value: "feature", label: "Feature Request" },
  { value: "feedback", label: "General Feedback" },
  { value: "support", label: "Support Request" },
];

export const CONTACT_LIMITS = {
  description: 5000,
  behaviour: 2000,
  email: 254,
  pageUrl: 2048,
  name: 100,
  organisation: 200,
} as const;

export interface ContactPayload {
  request_type: ContactRequestType;
  description: string;
  expected_behaviour?: string;
  actual_behaviour?: string;
  contact_email?: string;
  // Only asked of anonymous submitters, to narrow down which account they're on.
  name?: string;
  organisation?: string;
  // Collected by the page, not typed by the user. Who sent it comes from the
  // session on the backend, so nothing about the user is sent from here.
  browser_name: string;
  browser_version: string;
  os_name: string;
  timestamp: string;
  timezone: string;
  page_url?: string;
  page_name?: string;
  turnstile_token?: string;
}

export const submitContactForm = (payload: ContactPayload) =>
  apiRequest<ApiResponse>("/contact", {
    method: "POST",
    body: JSON.stringify(payload),
    skipAuthLogout: true,
  });
